export interface IApplicationDetails {
  status: string;
  product: string;
  name: string;
  applicationName: string;
  lineOfBusiness: string;
  createdBy: string;
  createdOn: string;
  modifiedBy: string;
  modifiedOn: string;
  statusReason: string;

  effectiveDate: string;
  expiryDate: string;
  isRenewal: string;
  renewalNumber: string;

  title: string;
  firstName: string;
  middleName: string;
  lastName: string;
  email: string;
  phoneType: string;
  mobileNumber: string;
  country: string;
  city: string;
  street: string;
  building: string;
  introducedBy: string;

  insuredName: string;
  insuredFirstName: string;
  insuredMiddleName: string;
  insuredLastName: string;
  insuredDateofBirth: string;
  insuredNationality: string;
  insuredGender: string;
  insuredPassportNumber: string;
  insuredOccupation: string;
  insuredPlan: string;

  agencyName: string;
  agentName: string;
  customerName: string;
  ratingType: string;
}

export const initialValues: IApplicationDetails = {
  status: '',
  product: '',
  name: '',
  applicationName: '',
  lineOfBusiness: '',
  createdBy: '',
  createdOn: '',
  modifiedBy: '',
  modifiedOn: '',
  statusReason: '',

  effectiveDate: '',
  expiryDate: '',
  isRenewal: 'NO',
  renewalNumber: '',
  insuredPlan: '',
  title: '',
  firstName: '',
  middleName: '',
  lastName: '',
  email: '',
  phoneType: 'MOBILE',
  mobileNumber: '',
  country: 'LB',
  city: '',
  street: '',
  building: '',
  introducedBy: '',

  insuredName: '',
  insuredFirstName: '',
  insuredMiddleName: '',
  insuredLastName: '',
  insuredDateofBirth: '',
  insuredNationality: '',
  insuredGender: '',
  insuredPassportNumber: '',
  insuredOccupation: '',

  agencyName: '',
  agentName: '',
  customerName: '',
  ratingType: '',
};
